export default "__VITE_ASSET__6yhPZER1__"